import makeStyles from "@mui/styles/makeStyles";
import { Theme, alpha } from "@mui/material/styles";

const styles = {
    sideBarStyles: makeStyles((theme: Theme) => ({
        accordionRoot: {
            backgroundColor: "transparent",
            boxShadow: "none",
            width: "100%",
            "& > div": {
                paddingLeft: "0px !important",
                "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
            },
            "& .MuiAccordionSummary-root": {
                minHeight: "initial",
            },
            "& .MuiAccordionSummary-content": {
                margin: 0,
            },
            "& .MuiAccordionSummary-content.Mui-expanded": {
                margin: 0,
            },
            "& .MuiAccordionSummary-root.Mui-expanded": {
                minHeight: "initial",
            },
            "& .MuiAccordionSummary-expandIconWrapper": {
                color: theme.palette.common.white,
                marginRight: 0,
            },
            "& .MuiAccordionDetails-root": {
                padding: "0px 16px 0px",
            },
            "& .MuiTypography-root": {
                color: theme.palette.common.white,
                margin: 0,
                "&:first-child": {
                    fontSize: 14,
                    fontWeight: "bold",
                    padding: "0px 14px 0px 0px",
                    marginLeft: 0,
                },
            },
        },
        drawer: {
            "& .MuiDrawer-paper": {
                borderRight: "none",
                width: "100%",
                background: `linear-gradient(180deg, ${theme.palette.gradients.g01.n1} 27.26%, ${theme.palette.gradients.g01.n2} 58.32%, ${theme.palette.gradients.g01.n3} 93.91%, ${theme.palette.gradients.g01.n3} 109.06%)`,
                ...theme.mixins.sideBar,
            },
            "& ::-webkit-scrollbar-thumb": {
                backgroundColor: theme.palette.secondary.main,
                borderRadius: 20,
            },
            "& ::-webkit-scrollbar-track": {
                backgroundColor: theme.palette.neutrals.light,
            },
        },
        mainLogo: {
            display: "flex",
            padding: theme.spacing(2, 2, 0),
            "& img": {
                width: "fit-content",
            },
        },
        hubSelector: {
            color: theme.palette.common.white,
            padding: theme.spacing(0, 1.5, 2.5, 1.5),
            margin: theme.spacing(0, 1, 2),
            borderBottom: `1px solid ${theme.palette.neutrals.light}60`,
            alignItems: "center",
        },
        hubSelectorTitle: {
            letterSpacing: "1.25px",
            marginBottom: theme.spacing(1),
            color: theme.palette.common.white,
        },
        hubSelectorTrigger: {
            color: theme.palette.common.white,
            "& .MuiSvgIcon-root": {
                fontSize: 16,
            },
        },
        hubSelectorPopoverPaper: {
            borderRadius: 16,
            marginTop: theme.spacing(1),
        },
        hubSelectorMenu: {
            width: 255,
            maxHeight: 244,
            padding: theme.spacing(2),
            borderRadius: theme.spacing(2),
            display: "flex",
            flexDirection: "column",
        },
        hubSelectorMenuTitle: {
            fonSize: 12,
            fontWeight: 600,
            letterSpacing: 1.5,
            textTransform: "uppercase",
            marginBottom: theme.spacing(2),
            color: theme.palette.secondary.main,
        },
        hubSelectorMenuList: {
            overflowY: "auto",
            paddingBottom: theme.spacing(2),
        },
        hubSelectorMenuItem: {
            "& .MuiButtonBase-root": {
                padding: 0,
            },
            "&:not(:last-child)": {
                marginBottom: theme.spacing(2),
            },
        },
        sysadminWrapper: {
            display: "block",
            alignItems: "center",
            marginBottom: theme.spacing(3),
        },
        sysadminItem: {
            height: 46,
            display: "flex",
            alignItems: "center",
            textDecoration: "inherit",
            paddingLeft: theme.spacing(2),
            color: theme.palette.common.white,
            "& .MuiTypography-root": {
                fontSize: 14,
            },
            "&:hover": {
                background: `linear-gradient(90deg, ${theme.palette.button.active.from} 0%, ${theme.palette.button.active.to} 142.5%)`,
            },
        },
        sysadminItemSelected: {
            background: `linear-gradient(90deg, ${theme.palette.button.active.from} 0%, ${theme.palette.button.active.to} 142.5%)`,
        },
        userAccountItem: {
            display: "flex",
            textDecoration: "none",
            height: 46,
            "& a": {
                flex: 1,
                textDecoration: "inherit",
                display: "flex",
                paddingLeft: theme.spacing(2),
                "& .MuiTypography-root": {
                    fontSize: 16,
                    fontWeight: 700,
                    marginLeft: theme.spacing(1),
                },
            },
        },
        userAccountItemSelected: {
            background: `linear-gradient(90deg, ${theme.palette.button.hover1.from} 0%, ${theme.palette.button.hover1.to} 100%)`,
        },
        userSettingsWrapper: {
            width: "100%",
            padding: theme.spacing(1),
            "&::before": {
                content: '""',
                display: "block",
                position: "relative",
                border: `1px solid ${theme.palette.neutrals.light}`,
                opacity: 0.5,
                margin: theme.spacing(1, 0),
            },
        },
        userSettingsUserNameWrapper: {
            position: "relative",
            "& > button": {
                position: "absolute",
                top: 13,
                right: 24,
            },
            "& $userSettingsLink": {
                outline: "none",
                "& .MuiTypography-root": {
                    maxWidth: 140,
                    textOverflow: "ellipsis",
                    whiteSpace: "pre",
                    overflow: "hidden",
                },
            },
        },
        userSettingsLink: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            color: theme.palette.common.white,
            width: "100%",
            height: 48,
            paddingLeft: theme.spacing(2.5),
            letterSpacing: 0,
            borderRadius: theme.spacing(1),
            textDecoration: "none",
            "& .MuiSvgIcon-root": {
                fontSize: 16,
                color: theme.palette.common.white,
                marginRight: theme.spacing(1),
            },
            "& .MuiTypography-root": {
                fontSize: 16,
                fontWeight: "400 !important",
            },
            "&:hover": {
                background: `linear-gradient(90deg, ${theme.palette.button.active.from} 0%, ${theme.palette.button.active.to} 142.5%)`,
                "& .MuiTypography-root": {
                    fontWeight: "700 !important",
                },
            },
            "&.active": {
                "& .MuiTypography-root": {
                    fontWeight: "700 !important",
                },
            },
        },
        tree: {
            color: theme.palette.common.white,
            scrollbarWidth: "thin",
            "& ul.MuiCollapse-root .MuiCollapse-wrapperInner > a:last-child .MuiTimelineSeparator-root > span.MuiTimelineConnector-root:last-child, & ul.MuiCollapse-root .MuiCollapse-wrapperInner > li:last-child .MuiTimelineSeparator-root > span.MuiTimelineConnector-root:last-child":
                {
                    background: "none",
                },
            "& li": {
                minHeight: 46,
                "& > div": {
                    height: 46,
                    padding: 0,
                },
            },
            "& > li": {
                "& > div": {
                    padding: 0,
                    "& > div": {
                        "&:nth-child(1)": {
                            order: 2,
                            display: "block",
                            marginTop: theme.spacing(1),
                            paddingRight: theme.spacing(1.6),
                        },
                        "&:nth-child(2)": {
                            fontSize: 16,
                            paddingLeft: theme.spacing(2),
                        },
                    },
                },
            },
            "& a": {
                color: "inherit",
                textDecoration: "inherit",
            },
            "& .MuiTreeItem-content.Mui-disabled": {
                cursor: "default",
            },
            "& .MuiTreeItem-root > .MuiTreeItem-content .MuiTreeItem-label:hover": {
                fontWeight: 400,
            },
            "& .MuiTreeItem-group": {
                marginLeft: 0,
                paddingLeft: 0,
            },
            "& .MuiTreeItem-iconContainer": {
                width: "auto",
                "& > svg": {
                    fontSize: "2.4rem",
                },
                "& .circle-active": {
                    fontSize: 8,
                },
                "& .MuiTimeline-root": {
                    padding: 0,
                },
                "& .MuiTimelineDot-root": {
                    margin: theme.spacing(0, 0, 0, 0),
                    width: 18,
                    height: 18,
                    borderWidth: 1,
                    "&:first-child": {
                        margin: theme.spacing(1.8, 0, 0, 0),
                    },
                    "&:last-child": {
                        margin: theme.spacing(0, 0, 1.8, 0),
                    },
                },
                "& .MuiTimelineItem-root": {
                    "&::before": {
                        padding: 0,
                    },
                },
                "& .MuiTimelineSeparator-root": {
                    "& .MuiTimelineDot-root": {
                        borderColor: theme.palette.common.white,
                    },
                    "& .MuiTimelineConnector-root": {
                        backgroundColor: theme.palette.common.white,
                        width: 1,
                    },
                },
            },
            "& a.active > .MuiTreeItem-root": {
                background: alpha(theme.palette.secondary.main, 0.5),
            },
        },
    })),
};

export default styles;
